<template>
    <TxRendererScreenshotArea>
        <PosterText/>
    </TxRendererScreenshotArea>
</template>

<script>
    import PosterText from './PosterText'
    import PosterTextTitle from './PosterTextTitle'
    import PosterTextModule from "../store-mixin";

    export default {
        name: 'PosterTextProduct',
        mixins: [PosterTextModule()],
        components: {
            PosterText,
            PosterTextTitle,
        },
    }
</script>

<style scoped lang="scss">

</style>

